<template>
  <div class="my-box">
    <van-pull-refresh v-model="isLoading" @refresh="refresh()">
    <div class="my-top">
      <div class="headbox">
        <van-image
            round
            :src="fileDisplayPrefix + (user || {}).userHeader"
        />
        <h2>{{(user || {}).fullName}}</h2>
        <p>{{(user || {}).mobileNum}}</p>
      </div>
      <img style="position: absolute; z-index: 1; left: 0; top: 0; width: 100%" src="@/assets/my-img.png">
    </div>

    <div class="my-fun">
      <van-cell is-link @click="getIinformation()">修改个人信息</van-cell>
      <!--<van-cell is-link @click="getCampusCard()">我的校园卡</van-cell>-->
      <van-cell is-link @click="gotoReserve()">我的预约</van-cell>
      <van-cell is-link @click="getCustomer()">我的客服</van-cell>
      <van-cell is-link @click="orderHxScan()" v-if="user.verifier === '1'">订单核销</van-cell>
      <van-cell is-link @click="stock()" v-if="user.stockView === '1'">库存查询</van-cell>
    </div>
    </van-pull-refresh>

  </div>
</template>

<script>
  import {getUserInfo,getUrlSchema} from "@/api/my/my";
  import {FILE_DISPLAY_PREFIX} from "../../api/upload";
  export default {
    name: 'my',
    components: {
    },
    data () {
      return {
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        isLoading: false,
        user: {}
      }
    },
    computed: {
    },
    created () {
      this.refresh()
    },
    mounted () {
    },
    methods: {
      refresh(){
        this.getUserInfo()
        setTimeout(() => {
          this.isLoading = false;
          this.count++;
        }, 1000);
      },
      getUserInfo(){
        getUserInfo().then(res => {
          if (res.code === 10000){
            this.user = res.result || {}
          }
        })
      },
      getCustomer(){
        getUrlSchema().then(res => {
          if (res.code === 10000){
            location.href= res.result
          }
        })
      },
      orderHxScan(){
        this.$router.push({path: `/my/orderHxScan`})
      },
      getIinformation(){
        this.$router.push({path: `/my/information`})
      },
      getCampusCard(){
        this.$router.push({path: `/my/campusCard`})
      },
      // 预约列表
      gotoReserve(){
        this.$router.push({path: `/order/index`})
      },
      stock(){
        this.$router.push({path: `/my/stockList`})
      }
    }
  }
</script>

<style scoped>
.my-fun{
  padding:10px;
}
/deep/.van-cell{
  margin: 5px 0;
  height:58px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(12,3,6,0.05);
  border-radius:6px;
  display: flex;
  align-items: center;
}
/deep/.van-cell__value--alone{
  display: flex;
  align-items: center;
}
.my-top{
  height:180px;
  background: #2C68E4;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}
.headbox{
  height:140px;
  background: rgba(9,22,70,0.5);
  box-shadow: 0px 16px 27px 2px rgba(160,159,159,0.95);
  border-radius:6px 6px 0 0;
  position: relative;
  z-index: 666;
  display: flex;
  width: 96%;
  margin: 0 2%;
  align-items: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/deep/.van-image{
  width:60px;
  height:60px;
  background: rgba(255,255,255,0.4);
  border-radius: 50%;
  padding: 5px;
}
.headbox h2{
  display: flex;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #EEF3F8;
  margin: 11px 0;
}
.headbox p{
  display: flex;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>
